import { ISalePageGachaRankResponse } from '@/api/types';
import { AppImage } from '@/components';
import { Element, Ellipsis, Row } from '@vuddy/components';
import * as styles from './gachaRankingItem.css';

interface IGachaRankingItemProps {
  item: ISalePageGachaRankResponse;
}

const GachaRankingItem = ({ item }: IGachaRankingItemProps) => {
  if (!item) return null;

  const rank = item.rank as 1 | 2 | 3 | 4 | 5;

  return (
    <Element as="li" className={styles.rankingItem({ rank: rank })}>
      <Row alignItems="center" height={40}>
        {rank === 1 && <Element className={styles.shadow} />}

        <Element backgroundColor="transparent" className={styles.iconContainer}>
          <AppImage
            src={item.profileImage?.url || '/images/user_random_profile.png'}
            width={32}
            height={32}
            alt="icon"
            className={styles.icon}
          />
          {rank === 1 && <Element className={styles.crown} />}
        </Element>
        <Ellipsis typography={rank === 1 ? 'bodyBaseAccent' : 'bodyXsAccent'}>
          {item.userName || '-'}
        </Ellipsis>
      </Row>
    </Element>
  );
};

export default GachaRankingItem;
